export const MenuItems = [
    { title: 'דשבורד', path: '/dashboard', icon: 'fas fa-fw fa-tachometer-alt', subMenu: [] },
    { title: 'העלאת קבצים', path: '/upload', icon: 'fas fa-fw fa-upload', subMenu: [] },
    { title: 'השיטות שלנו', path: '/are_method', icon: 'fas fa-fw fa-table',subMenu: []},
    { title: 'קשרי קהילה', path: '/Social', icon: 'fas fa-fw fa-table',subMenu: []},
    { title: 'פרויקטים', path: '/Projects', icon: 'fas fa-fw fa-table',subMenu: []},
    { title: 'אודות', path: '/About', icon: 'fas fa-fw fa-table',subMenu: []},

]
